import { useContext } from 'react';

import SnackbarContext from '@/contexts/Snackbar/SnackbarContext';

export default function useSnackbar() {
  const context = useContext(SnackbarContext);

  if (!context) {
    throw new Error('useSnackbar needs to be inside SnackbarContext');
  }

  return context;
}
